import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/global.css"; // Import Global Styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// NOTE: axiosConfig.js removed - it conflicted with apiClient.ts interceptors
// The apiClient.ts handles all auth, token refresh, and error handling properly
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient.ts';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { ToastProvider } from './contexts/ToastContext.tsx';
import { logBuildInfo } from './buildInfo.ts';

// Log build info at startup for version tracking
logBuildInfo();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Providers are OUTSIDE BrowserRouter to prevent remounts on navigation
  // This ensures the provider tree is stable and only mounts once
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  </QueryClientProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
